export default __webpack_public_path__ + "static/DSC_0165-88e780e652ab37adff01a85701a2fdea.jpg";